import axios from "@/util/axios";

const PREFIX_URI = "/order/stock/assembly";

export default {
    /** 分页查询组装拆分单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询组装拆分单详情（含明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存组装拆分单（草稿） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 提交组装拆分单 */
    submit: (id) => axios.post({url: `${PREFIX_URI}/submit?id=${id}`}),
    /** 删除组装拆分单 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 查询所有组装拆分模板 */
    queryAllTemplate: () => axios.get({url: `${PREFIX_URI}/queryAllTemplate`}),
}
